import { usePopper } from "@pinkyhead/dovekit";
import { useAuth } from "../../../context/auth";

export const useUser = () => {
  const { user, logout } = useAuth();
  const { popperOpen, togglePopperOpen } = usePopper();

  const redirectToLoginPage = () => {
    window.location.href = ("/dovemed-sso/?next=" + window.location.href);
  }

  const redirectToCoreProfile = () => {
    window.location.href = "/accounts/profile/physician/";
  }


  return {
    redirectToLoginPage,
    popperOpen,
    togglePopperOpen,
    user,
    logout,
    redirectToCoreProfile
  }
}